module.exports = __webpack_public_path__ + "img/soft-grove-kitchen-1.3eb094e0.jpeg";